import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { useAnniversary, useInfo } from '@/store';
import { ref, computed } from 'vue';
import ScheduleItemFigure from './ScheduleItemFigure.vue';
import ScheduleItemText from './ScheduleItemText.vue';
import { Status } from '@/types/enums';
import { isPC } from '@/hooks/useCheck';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleItem',
  props: {
    top: null,
    index: null,
    deeplink: null,
    title: null,
    startTime: null,
    endTime: null,
    prizeImage: null,
    prizeName: null,
    status: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "660806b3": (_unref(prizeFrameActive).pc),
  "7c282962": (_unref(prizeFrameActive).mobile),
  "6019eeae": (_unref(knife).pc),
  "14354058": (_unref(knife).mobile)
}))


const touchedItem = ref<number | null>(null);
const { chooseScheduleItem } = useAnniversary();
const { getImg } = useInfo();
const prizeFrameActive = computed(() => ({
  pc: `url(${getImg('anniversary_pc_prize_frame_active')})`,
  mobile: `url(${getImg('anniversary_mobile_prize_frame_active')})`,
}));
const knife = computed(() => ({
  pc: `url(${getImg('anniversary_pc_knife')})`,
  mobile: `url(${getImg('anniversary_mobile_knife')})`,
}));
const updateTouchedItem = (val: number | null) => {
  touchedItem.value = val;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    class: _normalizeClass([
      'item',
      {
        pc: _unref(isPC),
        open: __props.status === _unref(Status).Open,
        close: __props.status === _unref(Status).Close,
      },
    ]),
    onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (updateTouchedItem(__props.index))),
    onTouchend: _cache[1] || (_cache[1] = ($event: any) => (updateTouchedItem(null))),
    onTouchcancel: _cache[2] || (_cache[2] = ($event: any) => (updateTouchedItem(null))),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(chooseScheduleItem)(__props.index)))
  }, [
    (__props.top === 'figure')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(ScheduleItemFigure, {
            className: 'figure--top',
            index: __props.index,
            status: __props.status,
            prizeImage: __props.prizeImage,
            prizeName: __props.prizeName
          }, null, 8, ["index", "status", "prizeImage", "prizeName"]),
          _createVNode(ScheduleItemText, {
            className: 'text--bottom',
            index: __props.index,
            title: __props.title,
            status: __props.status,
            deeplink: __props.deeplink,
            startTime: __props.startTime,
            endTime: __props.endTime
          }, null, 8, ["index", "title", "status", "deeplink", "startTime", "endTime"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(ScheduleItemText, {
            className: 'text--top',
            index: __props.index,
            title: __props.title,
            status: __props.status,
            deeplink: __props.deeplink,
            startTime: __props.startTime,
            endTime: __props.endTime
          }, null, 8, ["index", "title", "status", "deeplink", "startTime", "endTime"]),
          _createVNode(ScheduleItemFigure, {
            className: 'figure--bottom',
            index: __props.index,
            status: __props.status,
            prizeImage: __props.prizeImage,
            prizeName: __props.prizeName
          }, null, 8, ["index", "status", "prizeImage", "prizeName"])
        ], 64))
  ], 34))
}
}

})